import { useApps } from './hooks/use-apps';
import { useCrmAccounts } from './hooks/use-crm-accounts';
import { OutlookAuthCard } from './components/outlook-auth-card';
import { Button } from '@shadcn/ui/components/ui/button';
import { X } from 'lucide-react';
import { GmailAuthCard } from './components/gmail-auth-card';
import { Alert, AlertDescription } from '@shadcn/ui/components/ui/alert';
import { LinkedInAuthCard } from './components/linkedin-auth-card';
import { HubspotAuthCard } from './components/hubspot-auth-card';
import { PipedriveAuthCard } from './components/pipedrive-auth-card';
import { SalesforceAuthCard } from './components/salesforce-auth-card';

export const AppsPage = () => {
    const { accounts, error, clearError } = useApps();

    const { accounts: crmAccounts, isLoading: crmLoading, disconnectCrm } = useCrmAccounts();

    return (
        <div className="container py-0 space-y-6">
            <div className="flex items-center justify-between">
                <h1 className="text-2xl font-bold tracking-tight">Connect your apps</h1>
            </div>

            {error && (
                <div
                    className="transition-opacity duration-300 ease-in-out opacity-100"
                    onTransitionEnd={(e) => {
                        if (
                            e.propertyName === 'opacity' &&
                            e.target === e.currentTarget &&
                            e.currentTarget.style.opacity === '0'
                        ) {
                            clearError();
                        }
                    }}
                >
                    <Alert variant="destructive" className="mb-4">
                        <div className="flex items-center justify-between w-full">
                            <div dangerouslySetInnerHTML={{ __html: error }} />
                            <AlertDescription>
                                <Button
                                    variant="ghost"
                                    size="sm"
                                    className="h-6 w-6 p-0"
                                    onClick={(e) => {
                                        (e.currentTarget.closest('.transition-opacity') as HTMLElement).style.opacity =
                                            '0';
                                    }}
                                >
                                    <X className="h-4 w-4" />
                                </Button>
                            </AlertDescription>
                        </div>
                    </Alert>
                </div>
            )}
            <div>
                <h2 className="text-xl font-medium mb-4 border-b pb-1">Social</h2>

                <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
                    <LinkedInAuthCard account={accounts.linkedin} />
                    {/* Additional social account cards can be added here */}
                </div>
            </div>
            <div>
                <h2 className="text-xl font-medium mb-4 border-b pb-1">Email</h2>

                <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
                    {!accounts.gmail.isAdded && !accounts.outlook.isAdded ? (
                        <>
                            <GmailAuthCard account={accounts.gmail} />
                            <OutlookAuthCard account={accounts.outlook} />
                        </>
                    ) : accounts.gmail.isAdded ? (
                        <GmailAuthCard account={accounts.gmail} />
                    ) : (
                        <OutlookAuthCard account={accounts.outlook} />
                    )}
                </div>
            </div>

            <div>
                <h2 className="text-xl font-medium mb-4 border-b pb-1">CRM</h2>
                <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
                    <HubspotAuthCard
                        isActive={crmAccounts?.hubspot?.settings?.isActive}
                        isConnected={!!crmAccounts?.hubspot?.settings}
                        isLoading={crmLoading}
                        onConnect={() => {}}
                        onDisconnect={() => disconnectCrm('hubspot')}
                    />
                    <PipedriveAuthCard
                        isActive={crmAccounts?.pipedrive?.settings?.isActive}
                        isConnected={!!crmAccounts?.pipedrive?.settings}
                        isLoading={crmLoading}
                        onConnect={() => {}}
                        onDisconnect={() => disconnectCrm('pipedrive')}
                    />
                    <SalesforceAuthCard
                        isActive={crmAccounts?.salesforce?.settings?.isActive}
                        isConnected={!!crmAccounts?.salesforce?.settings}
                        isLoading={crmLoading}
                        onConnect={() => {}}
                        onDisconnect={() => disconnectCrm('salesforce')}
                    />
                </div>
            </div>
        </div>
    );
};
